import { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
type PageTitleProps = {
    title: string;
}
export default function PageTitle({ children, title }: PropsWithChildren<PageTitleProps>) {
    const { t } = useTranslation('titles')
    document.title = t(title)
    if (children)
        return (
            children
        )
    else return <Outlet />
}